import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const { member, isAuthenticated, isLoading } = useAuth();
  const [hasCheckedAuth, setHasCheckedAuth] = React.useState(false);

  React.useEffect(() => {
    // Give auth context time to load from storage
    const timer = setTimeout(() => {
      setHasCheckedAuth(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading || !hasCheckedAuth) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Double-check tokens exist before redirecting
    const hasToken = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
    if (hasToken) {
      console.log('[ProtectedRoute] Has token but not authenticated, waiting...');
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
        >
          <CircularProgress />
        </Box>
      );
    }
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && member && !allowedRoles.includes(member.memberType)) {
    return <Navigate to="/voicemail" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;